import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    banner: {
      marginBottom: theme.spacing(5),
    },
    container: {
      width: '100%',
      margin: '0 auto',
      [theme.breakpoints.down('md')]: {
        maxWidth: '80vw',
      },
    },
    form: {
      width: '100%',
    },
    title: {
      marginBottom: theme.spacing(6),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(4),
      },
    },
    fields: {
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(6),
      },
    },
    input: {
      marginBottom: theme.spacing(3),
    },
    primaryButton: {
      marginLeft: theme.spacing(2),
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(3),
    },
  })
);
